import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "17. maj",
  "description": "",
  "published": "2007-05-28T00:00:00.000Z",
  "redirect_from": ["/blog/17-maj/swizec/200"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes se je zgodilo nekaj zanimivh reÄi, vendar ta blog ne govori o njih, o ne, shranjene so za drugiÄ. Raje vam podam`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Gonzo_journalism"
      }}>{` gonzo`}</a>{` pripoved o sobotnem veÄeru.`}</p>
    <p>{`Ker pa sem len, jo lahko preberete le v `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=230"
      }}>{`anglešÄini`}</a>{`. PaÄ se mi je pisala v anglešÄini, se zgodi.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      